/**
 * @file 編集権限のない場合に編集画面はreadonlyにする
 */
'use strict'

/**
 * @classname EditReadOnly
 * @classdesc 編集権限のない場合に編集画面はreadonlyにする
 */
export default class EditReadOnly {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 */
	constructor($e, controller) {
		console.log('EditReadOnly.constructor')
		this._$e = $e
		this._controller = controller

		this._$input = $e.find('input')

		this._$input.each((idx, e) => {
			const $this = $(e)
			const _type = $(e).attr('type')

			if ($this.attr('data-datepicker') === 'true') {
				$this.prop('disabled', true);
				$this.attr('data-datepicker', false);
			} else if (_type ==='checkbox' || _type === 'radio' ) {
				$this.prop('disabled', true);
			} else {
				$this.prop('readonly', true);
			}
		})

		this._$e.find('textarea').each((idx, e) => {
			const $this = $(e)
			$this.prop('readonly', true);
		})

		this._$e.find('select').each((idx, e) => {
			const $this = $(e)
			$this.prop('disabled', true);
		})

		// Editor.js
		this._$e.find('#codex-editor').each((idx, e) => {
			console.log('Editorjsがあります')
			const $this = $(e)
			$this.addClass('readonly')
			$this.find('input').css('pointer-events', 'none');
		})

		// 画像
		this._$e.find('.block-file-upload').each((idx, e) => {
			const $this = $(e)
			$this.find('label').css('display', 'none');
			$this.find('button').css('display', 'none');
		})

		// セクション削除ボタン非表示
		this._$e.find('button[data-template-area-type="delete"]').each((idx, e) => {
			const $this = $(e)
			$this.css('display', 'none');
		})

		// セクション追加ボタン非表示
		this._$e.find('button[data-template-area-type="trigger"]').each((idx, e) => {
			const $this = $(e)
			$this.css('display', 'none');
		})

	}
}
